import { defineMessages } from 'react-intl';

export default defineMessages({
    article6Excluded: {
        id: 'wmic-pe-capability-gateway-common-pa-react.DriverEndorsementsCoverages.Article6_Excluded_Driver',
        defaultMessage: 'Article6 - Excluded &lt;b&gt;{name}&lt;/b&gt;',
    },
});
